import { JSX, useEffect } from "react";
import { ClaimsActivityVolumeLabelEnum } from "@app/projects/network-assessment/pci-dashboard/claims-activity";
import { DropdownItem, MultiselectDropdown } from "@app/shared/checkbox-dropdown";

interface VolumeLabelFilterProps {
  mappedVolumeLabels: DropdownItem<ClaimsActivityVolumeLabelEnum>[];
  selectedVolumeLabels: DropdownItem<ClaimsActivityVolumeLabelEnum>[];
  setSelectedVolumeLabels: (selectedVolumeLabels: DropdownItem<ClaimsActivityVolumeLabelEnum>[]) => void;
  testId: string;
}

const VolumeLabelFilter = (props: VolumeLabelFilterProps): JSX.Element => {
  useEffect(() => {
    props.setSelectedVolumeLabels(props.mappedVolumeLabels);
  }, []);

  return (
    <MultiselectDropdown
      containerClassName="d-block"
      customSelectInputText={props.mappedVolumeLabels.length === props.selectedVolumeLabels.length ? "All" : null}
      items={props.mappedVolumeLabels}
      onSelectionChanged={(selectedVolumeLabels: DropdownItem<ClaimsActivityVolumeLabelEnum>[]) => { props.setSelectedVolumeLabels(selectedVolumeLabels) }}
      label="Volume Indicator"
      selectedItems={props.selectedVolumeLabels}
      testId={props.testId}
      validationTooltipContent="Provider claims status in the selected line of business"
    />
  )
}

export default VolumeLabelFilter;
